module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/149.db918e47.png";